/**
 * Constants for volume action tooltips and disabled tooltips
 * Used across VolumeDetailsPage and VolumesListPage components
 */

export const VOLUME_ACTION_TOOLTIPS = {
  // Single volume operation tooltips
  EDIT_METADATA_SINGLE: 'You can only edit metadata for a single volume at a time',
  UPLOAD_IMAGE_SINGLE: 'You can only upload one volume as an image at a time',
  EDIT_SINGLE: 'You can only edit one volume at a time',
  SNAPSHOT_SINGLE: 'You can only create a snapshot of one volume at a time',
  EXTEND_SINGLE: 'You can only extend one volume at a time',
  ATTACH_SINGLE: 'You can only attach one volume at a time',
  DETACH_SINGLE: 'You can only detach one volume at a time',
  CANCEL_TRANSFER_SINGLE: 'You can only cancel a transfer for a single volume at a time',

  // Status-based tooltips
  ATTACH_AVAILABLE_STATUS: 'You can only attach a volume when it is in the available status',
  DETACH_IN_USE_STATUS: 'You can only detach a volume when it is in the in-use status',
  RETYPE_AVAILABLE_STATUS: 'You can only retype a volume when it is in the available status',
  RETYPE_AVAILABLE_IN_USE_STATUS:
    'You can only retype a volume when it is in the available or in-use status',
  TRANSFER_AVAILABLE_STATUS: 'You can only transfer a volume when it is in the available status',
  CANCEL_TRANSFER_AWAITING_STATUS:
    'You can only cancel a transfer when it is in the awaiting-transfer status',

  // Extend volume tooltips
  EXTEND_VOLUME_CONDITION:
    'You can extend a volume if it is available, or if it is in use but not using the NFS driver',

  // Migration tooltips
  MIGRATE_VOLUME_CONDITION:
    'You can only migrate a volume when it is in the available or in-use status and has no migration in progress',
  MIGRATE_ADMIN_ONLY: 'Only administrators are allowed to migrate volumes',

  // Retype tooltips
  RETYPE_OWN_VOLUMES: 'You can only retype your own volumes',
  RETYPE_OWN_VOLUMES_CONDITION:
    'You can only retype your own volumes, and the volume status must be available or in-use',

  // Transfer tooltips
  TRANSFER_CURRENT_TENANT: 'You can only transfer a volume that belongs to your current tenant',
  CANCEL_TRANSFER_CURRENT_TENANT:
    'You can only cancel a transfer for a volume that belongs to your current tenant',
} as const
